export default __webpack_public_path__ + "static/media/icon-512x512.177dd0a2.png";